<template>
  <div class="w-full border rounded-lg px-4 lg_px-8 py-12">
    <h1 class="text-center text-2xl font-semibold leading-none mb-12">Join Meeting</h1>
    <form class="space-y-6" @submit.prevent="onSubmit">
      <FormField v-slot="{ componentField }" name="guestName">
        <FormItem>
          <FormLabel class="font-medium text-sm">Name</FormLabel>
          <FormControl>
            <Input type="text" placeholder="Your Name" v-bind="componentField" class="border" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
      <Button type="submit" class="w-full">Continue as Guest</Button>
      <p class="text-center text-xs text-muted-foreground">
        By continuing, you agree to our
        <NuxtLink :to="`${config.public.WEB_ENDPOINT}legal/user-terms-of-service`" class="underline" target="_blank"
          >terms of service</NuxtLink
        >
        and <NuxtLink :to="`${config.public.WEB_ENDPOINT}legal/privacy-policy`" class="underline" target="_blank">privacy policy</NuxtLink>.
      </p>
    </form>
  </div>

  <Separator label="Or" class="my-6" />

  <MeetingsSocialLogin
    :meeting-code="props.meetingCode"
    :go-to-meeting="props.goToMeeting"
    @toggle-login-form="$emit('toggle-login-form')"
  />
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'

const emit = defineEmits(['submit', 'toggle-login-form'])

const props = defineProps<{
  meetingCode: string
  goToMeeting: () => void
}>()

const config = useRuntimeConfig()

const formSchema = toTypedSchema(
  z.object({
    guestName: z.string().min(1, 'Name is required'),
  }),
)

const { handleSubmit } = useForm({
  validationSchema: formSchema,
})

const onSubmit = handleSubmit(values => emit('submit', values.guestName))
</script>
